import { useState, useEffect } from 'react';
import { supabase } from '@/integrations/supabase/client';
import { useAuth } from '@/contexts/AuthContext';

export function useUserTournamentsCount(userId?: string) {
  const { user: authUser } = useAuth();
  const [tournamentsCount, setTournamentsCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const fetchTournamentsCount = async () => {
    try {
      setLoading(true);
      
      // Use provided userId or current user's id
      const targetUserId = userId || authUser?.id;
      if (!targetUserId) return;

      const { count, error } = await supabase
        .from('registrations')
        .select('*', { count: 'exact', head: true })
        .or(`user_id.eq.${targetUserId},partner_user_id.eq.${targetUserId}`)
        .eq('status', 'confirmed');

      if (error) throw error;
      setTournamentsCount(count || 0);
    } catch (err) {
      setError(err instanceof Error ? err.message : 'Failed to fetch tournaments count');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTournamentsCount();
  }, [userId, authUser?.id]);

  return {
    tournamentsCount,
    loading,
    error,
    refetch: fetchTournamentsCount
  };
}